import { cn } from "@/lib/chillnn/cn";

import type {
	SelectableSnackItemType,
	SnackBlocksFormModelContentsMethodsType,
} from "@/components/features/snack/snack/settings/model/usecase/use-create-snack-layout-settings-form-model/methods/contents";

import { DialogSelectSnack } from "../../../dialog/snack";

import { useSelectSnackModalState } from ".";

type Props = {
	hotelID: string;
	index: number;

	blockUUID: string;

	snack: SnackBlocksFormModelContentsMethodsType["blocks"]["value"][number]["items"]["value"][number];

	contentsMethods: SnackBlocksFormModelContentsMethodsType;

	heightTailwindStyle: string;
};

export const LayoutSettingsIslandContentRowEmptySnackItem = ({
	hotelID,
	blockUUID,
	index,
	contentsMethods,
	heightTailwindStyle,
}: Props) => {
	const { selectableSnacks, onAddSnackToBlock } = contentsMethods;
	const {
		activateSelectSnackModal,
		deactivateSelectSnackModal,
		isShowSelectSnackModal,
		handleOpenChangeSelectSnackModal,
	} = useSelectSnackModalState();

	return (
		<div className="flex flex-col items-center justify-center">
			<div
				role="button"
				onClick={activateSelectSnackModal}
				className={cn(
					"rounded-[20px] border border-zinc-100 bg-zinc-300 hover:bg-zinc-200", //
					"grid w-full place-content-center place-items-center",
					heightTailwindStyle,
				)}
			>
				<p>スナックを選択する</p>
			</div>

			<DialogSelectSnack
				hotelID={hotelID}
				onSelectSnack={({ selectedSnack }: { selectedSnack: SelectableSnackItemType }) =>
					onAddSnackToBlock({ blockUUID, snackIndex: index, selectedSnack })
				}
				open={isShowSelectSnackModal}
				handleClickCloseButton={deactivateSelectSnackModal}
				deactivateSelectSnackModal={deactivateSelectSnackModal}
				handleOpenChange={handleOpenChangeSelectSnackModal}
				selectableSnacks={selectableSnacks}
			/>
		</div>
	);
};

LayoutSettingsIslandContentRowEmptySnackItem.displayName = "LayoutSettingsIslandContentRowEmptySnackItem";
